import React from 'react';
import Styled from 'styled';
import defaultStyles from './skeleton-group.scss';

export interface Props {
    styles: typeof defaultStyles;
}

class SkeletonGroup extends React.PureComponent<Props> {
    render() {
        const { styles } = this.props;
        return (
            <div className={styles.group}>
                <div className={styles.image} />
                <div className={styles.groupInfo}>
                    <div className={styles.groupName} />
                    <div>
                        <div className={styles.groupStat} />
                    </div>
                </div>
            </div>
        );
    }
}

export default Styled(defaultStyles)(SkeletonGroup);
